<script>
    import Swipe from '../../utils/Swipe.js';
    import { outerWidth } from '../../utils/dom.js';
    import { nextTick } from 'vue';
    export default {
        data() {
            return {
                items: [],
                captions: [],
                imageInViewIndex: 0,
                zoomedImageIndex: undefined,
                transformWidth: 0,
                firstMargin: 0,
                initalWidthsCalculated: false,
                hasYoutubeVideo: false
            }
        },
        computed: {
            zoomActive() {
                return this.zoomedImageIndex !== undefined;
            },
            carouselTransform() {
                return { transform: 'translateX(-' + this.imageInViewIndex * this.transformWidth + 'px)' };
            },
            overlayTransform() {
                return { transform: 'translateX(' + this.imageInViewIndex * this.transformWidth + 'px)' };
            },
            scrollRightDisabled() {
                return this.zoomActive ? (this.zoomedImageIndex >= (this.items.length - 1)) : (this.items.length && this.imageInViewIndex >= (this.items.length - 1));
            },
            scrollLeftDisabled() {
                return this.zoomActive ? this.zoomedImageIndex < 1 : this.imageInViewIndex < 1;
            },
            isItemZoomed() {
                return this.zoomedImageIndex !== undefined;
            },
            isZoomedItemVideo() {
                return this.isItemZoomed && this.items[this.zoomedImageIndex].type === 'video';
            },
            blockElementID() {
                return this.$el.id;
            }
        },
        mounted() {
            let n = 0;
            this.itemRefs = this.$refs.carousel.querySelectorAll('.media-carousel-item');
            this.itemRefs.forEach(i => {
                this.items.push(JSON.parse(i.getAttribute('data-props')));
            });
            this.items.forEach(item => {
                this.captions.push(item.caption ? item.caption : item.title);
                if (item.type === 'video' && item.format !== 'mp4') {
                    this.hasYoutubeVideo = true;
                    if (!this.firstYoutubeVideo) {
                        this.firstYoutubeVideo = item;
                        this.zoomAndPlay(n);
                    }
                }
                n++;
            });

            window.addEventListener('resize', this.updateItemWidths);
            this.updateItemWidths();
            const swipeCarousel = new Swipe(this.$refs.carousel).onLeft(this.scrollRight).onRight(this.scrollLeft);
            swipeCarousel.run();
            const swipeZoom = new Swipe(this.$refs.zoomed).onLeft(this.scrollRight).onRight(this.scrollLeft);
            swipeZoom.run();

            let imgId = this.getUrlParameter('img');
            let blockid = this.getUrlParameter('blockId');
            nextTick(() => {
                if (imgId && blockid && blockid === this.blockElementID) {
                    if (!isNaN(imgId) && imgId < this.items.length) {
                        var elmnt = document.getElementById(blockid);
                        elmnt.scrollIntoView();
                        window.scrollBy(0, -250)
                        this.zoomImage(this.items[imgId]);
                        this.updateTransformWidth();
                    }
                }

                if (this.hasYoutubeVideo) {
                    this.initYoutube();
                    this.closeImage();
                }
            });
        },
        methods: {
            handlePageChange(e) {
                this.imageInViewIndex = e.pageStart;
                this.updateTransformWidth();
            },
            updateTransformWidth() {
                var gutterWidth = window.innerWidth > 721 ? 23 : 18;
                this.transformWidth = this.itemRefs[this.imageInViewIndex].offsetWidth + gutterWidth;
            },
            scrollLeft(evt) {
                if (!this.scrollLeftDisabled) {
                    this.imageInViewIndex = Math.max(0, this.imageInViewIndex - 1);
                    if (this.zoomActive && this.zoomedImageIndex > 0) {
                        this.zoomedImageIndex--;
                    }
                    this.updateTransformWidth();

                    if (this.isZoomedItemVideo) {
                        this.zoomAndPlay(this.zoomedImageIndex);
                    }
                }
            },
            scrollRight(evt) {
                if (!this.scrollRightDisabled) {
                    if (!this.initalWidthsCalculated) {
                        this.updateItemWidths();
                        this.initalWidthsCalculated = true;
                    }
                    this.imageInViewIndex = Math.min(this.items.length - 1, this.imageInViewIndex + 1);
                    if (this.zoomActive) {
                        this.zoomedImageIndex = Math.min(this.items.length - 1, this.zoomedImageIndex + 1);
                    }
                    this.updateTransformWidth();

                    if (this.isZoomedItemVideo) {
                        this.zoomAndPlay(this.zoomedImageIndex);
                    }
                }
            },
            zoomImage(i) {
                this.zoomedImageIndex = i;
                document.addEventListener('click', this.closeOnClickOut);
                document.addEventListener('keyup', this.closeOnEscapePress);
            },
            zoomAndPlay(i) {
                this.zoomImage(i);
                this.$nextTick(() => {
                    this.handleVideoLoad(i);
                });
            },
            handleVideoLoad(i) {
                if (this.items[i].format === 'mp4') {
                    initializeVideoFileControls(this.$refs.zoomedVideo);
                }
                else {
                    if (document.getElementsByTagName('body')[0].classList.contains('has-piwik')) {
                        if (!this.youtubeInitialized) {
                            initVideoIfMarketingCookiesAccepted(this.initYoutube);
                        }
                        else {
                            this.initYoutube();
                        }
                    }
                    else {
                        initializeVideoYoutubeControls(this.$refs.zoomedVideo);
                    }
                }
            },
            initYoutube() {
                if (!this.youtubeInitialized) {
                    this.youtubeInitialized = true;
                    if (this.$refs.zoomedVideo) {
                        initializeVideoYoutubeControls(this.$refs.zoomedVideo);
                    }
                    this.$nextTick(function () {
                        this.closeImage();
                    });
                }
                else {
                    initializeVideoYoutubeControls(this.$refs.zoomedVideo);
                }
            },
            closeImage() {
                this.zoomedImageIndex = undefined;
                document.removeEventListener('click', this.closeOnClickOut);
                document.removeEventListener('keyup', this.closeOnEscapePress);
            },
            updateItemWidths() {
                const vm = this;
                this.itemRefs.forEach((f, i) => {
                    if (i === 0) {
                        const style = outerWidth(f, true);
                        this.items[i].width = style.width;
                        this.firstMargin = parseInt(style.style.marginRight);
                    } else {
                        this.items[i].width = outerWidth(f);
                    }
                });
                this.updateTransformWidth();
            },
            getUrlParameter(name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            },
            closeOnClickOut(e) {
                if (this.$refs.zoomed !== e.target && !this.$refs.zoomed.contains(e.target)) {
                    if (this.itemRefs[this.zoomedImageIndex] !== e.target && !this.itemRefs[this.zoomedImageIndex].contains(e.target)) {
                        this.closeImage();
                    }
                }
            },
            closeOnEscapePress(e) {
                if (e.which == 27) {
                    this.closeImage();
                }
            }
        }
    };
</script>